// Contenido legal centralizado. La MARCA es una constante para que el rebrand
// (Voras → Piamun) sea un solo cambio acá. La entidad legal NO cambia.
//
// ⚠️ Estos textos fueron redactados como base operativa para un SaaS B2B de una
// LLC de EEUU vendiendo a LATAM. Se recomienda revisión por un abogado antes de
// campañas de venta agresivas o clientes enterprise.

export const BRAND = "Voras"; // ← rebrand: cambiar acá (y solo acá) a "Piamun"
export const LEGAL_ENTITY = "Ficanaz LLC";
export const LEGAL_ADDRESS = "30 N Gould St, Ste R, Sheridan, WY 82801, Estados Unidos";
export const LEGAL_JURISDICTION = "Estado de Wyoming, Estados Unidos";
export const CONTACT_EMAIL = "contact@voras.com"; // ← actualizar con el dominio definitivo
export const LAST_UPDATED = "5 de julio de 2026";

export const terms = {
  title: "Términos y Condiciones",
  sections: [
    {
      h: "1. Quiénes somos y aceptación",
      p: [
        `${BRAND} es una plataforma de gestión de depósitos (WMS) operada por ${LEGAL_ENTITY}, una sociedad de responsabilidad limitada constituida en el ${LEGAL_JURISDICTION}, con domicilio en ${LEGAL_ADDRESS} (en adelante, "la Empresa", "nosotros").`,
        `Al crear una cuenta, acceder o utilizar ${BRAND} (el "Servicio"), usted ("el Cliente") acepta estos Términos y Condiciones. Si utiliza el Servicio en representación de una empresa, declara tener facultades para obligarla.`,
        `El Servicio está dirigido exclusivamente a empresas y personas que actúan en el marco de su actividad comercial (B2B). No está dirigido a consumidores finales.`,
      ],
    },
    {
      h: "2. El Servicio",
      p: [
        `${BRAND} permite gestionar inventario, ingresos y egresos de mercadería, preparación y despacho de pedidos, y sincronizar ventas desde canales de e-commerce (por ejemplo MercadoLibre, Tienda Nube y WooCommerce) mediante sus APIs oficiales.`,
        `El Servicio se provee "tal cual" (as is) y en modalidad de suscripción por planes, cada uno con un cupo mensual de egresos despachados. Alcanzado el cupo, las ventas de los canales se siguen recibiendo pero no pueden procesarse nuevos egresos hasta mejorar el plan o iniciar un nuevo ciclo.`,
        `Podemos modificar, agregar o discontinuar funcionalidades del Servicio. Los cambios sustanciales que reduzcan funcionalidad esencial serán comunicados con antelación razonable.`,
      ],
    },
    {
      h: "3. Cuenta y seguridad",
      p: [
        "El Cliente es responsable de la veracidad de los datos de registro, de la confidencialidad de sus credenciales y de toda actividad realizada desde su cuenta, incluyendo la de los usuarios colaboradores que invite.",
        "Debe notificarnos de inmediato cualquier acceso no autorizado. Podemos suspender cuentas ante indicios razonables de uso fraudulento, abuso o riesgo para la plataforma.",
      ],
    },
    {
      h: "4. Planes, precios y pagos",
      p: [
        `Los precios de los planes se expresan en dólares estadounidenses (USD) y se publican en la página de planes. Los pagos se procesan a través de Stripe, con renovación automática mensual o anual según la modalidad elegida.`,
        "Los precios no incluyen impuestos, percepciones ni cargos que el país, banco o emisor de la tarjeta del Cliente pudieran aplicar (por ejemplo impuestos a compras en el exterior), los cuales son responsabilidad exclusiva del Cliente.",
        "Podemos modificar los precios notificando con al menos 30 días de anticipación; el nuevo precio aplica a partir del ciclo siguiente a la notificación. Si el Cliente no está de acuerdo, puede cancelar antes de la renovación.",
        "La falta de pago habilita la suspensión del plan pago (la cuenta pasa a las condiciones del plan Free) hasta regularizar el pago.",
      ],
    },
    {
      h: "5. Cancelación y reembolsos",
      p: [
        "El Cliente puede cancelar su suscripción en cualquier momento desde el portal de facturación; la cancelación es efectiva al final del ciclo ya abonado, sin renovación posterior.",
        `Los pagos realizados no son reembolsables. ${BRAND} ofrece un plan Free sin costo ni tarjeta que permite evaluar el Servicio antes de contratar un plan pago. Ver la Política de Reembolsos para el detalle.`,
      ],
    },
    {
      h: "6. Datos del Cliente y de terceros",
      p: [
        "Los datos operativos cargados o sincronizados en la cuenta (productos, stock, pedidos, datos de compradores provenientes de los canales de venta) son y siguen siendo del Cliente. Nos otorga una licencia limitada para procesarlos con el único fin de prestar el Servicio.",
        "Respecto de los datos personales de los compradores del Cliente (nombre, dirección de envío, contacto), el Cliente actúa como responsable del tratamiento y la Empresa como encargada, procesándolos según sus instrucciones y la Política de Privacidad.",
        "El Cliente declara contar con base legal para sincronizar dichos datos y se obliga a cumplir la normativa de protección de datos que le resulte aplicable (en Argentina, la Ley 25.326).",
      ],
    },
    {
      h: "7. Integraciones de terceros",
      p: [
        "Las integraciones con plataformas de terceros (MercadoLibre, Tienda Nube, WooCommerce, transportistas, etc.) dependen de las APIs, términos y disponibilidad de dichas plataformas, que pueden cambiar sin nuestro control.",
        "No somos responsables por interrupciones, cambios o limitaciones originadas en dichas plataformas, sin perjuicio de nuestros esfuerzos razonables por adaptarnos con rapidez.",
      ],
    },
    {
      h: "8. Funcionalidades asistidas por inteligencia artificial",
      p: [
        `El Servicio puede incorporar funcionalidades asistidas por inteligencia artificial (por ejemplo, sugerencias, clasificaciones automáticas, predicciones o asistentes). Cuando una interacción sea generada por un sistema automatizado, ${BRAND} lo indicará de manera razonable.`,
        "Las salidas generadas por IA son asistivas y pueden contener errores: no constituyen asesoramiento y no reemplazan la revisión y decisión del Cliente, quien mantiene el control y la responsabilidad final sobre su operación.",
        "Los datos del Cliente no se utilizan para entrenar modelos de inteligencia artificial de terceros sin su consentimiento expreso.",
      ],
    },
    {
      h: "9. Uso aceptable",
      p: [
        "Está prohibido usar el Servicio para actividades ilícitas; intentar vulnerar su seguridad; revender o sublicenciar el acceso sin autorización; realizar ingeniería inversa; o someter la plataforma a cargas diseñadas para degradarla.",
        "Podemos suspender o terminar cuentas que violen esta cláusula, con notificación al Cliente.",
      ],
    },
    {
      h: "10. Propiedad intelectual",
      p: [
        `El software, la marca ${BRAND}, el diseño y la documentación son propiedad de la Empresa o de sus licenciantes. La suscripción otorga un derecho de uso limitado, no exclusivo e intransferible durante su vigencia, sin transferencia de propiedad alguna.`,
      ],
    },
    {
      h: "11. Disponibilidad y soporte",
      p: [
        "Realizamos esfuerzos comercialmente razonables para mantener el Servicio disponible y respaldado, sin garantizar disponibilidad ininterrumpida. Las ventanas de mantenimiento se procurarán fuera de horarios pico.",
        "El soporte se brinda por los canales indicados en la plataforma. Los planes Enterprise pueden acordar condiciones de soporte y disponibilidad (SLA) específicas por escrito.",
      ],
    },
    {
      h: "12. Limitación de responsabilidad",
      p: [
        "En la máxima medida permitida por la ley aplicable, la responsabilidad total y acumulada de la Empresa por cualquier reclamo derivado del Servicio se limita al monto efectivamente abonado por el Cliente en los 12 meses anteriores al hecho que origina el reclamo.",
        "La Empresa no responde por lucro cesante, pérdida de datos ajena a su culpa grave, daños indirectos ni consecuenciales. Nada en estos términos limita responsabilidades que no puedan limitarse legalmente.",
        "El Cliente reconoce que el Servicio es una herramienta de gestión: las decisiones operativas y comerciales (por ejemplo, despachar o no un pedido) son propias del Cliente.",
      ],
    },
    {
      h: "13. Terminación",
      p: [
        "El Cliente puede terminar la relación cancelando su suscripción y solicitando la baja de la cuenta. Podremos terminar estos términos ante incumplimientos graves no subsanados en un plazo razonable tras la notificación.",
        "Tras la baja, los datos del Cliente se conservan por un período limitado para permitir su exportación y luego se eliminan conforme a la Política de Privacidad.",
      ],
    },
    {
      h: "14. Ley aplicable y jurisdicción",
      p: [
        `Estos términos se rigen por las leyes del ${LEGAL_JURISDICTION}, sin aplicación de sus normas de conflicto de leyes. Toda controversia se someterá a los tribunales competentes de dicho estado, sin perjuicio de las normas imperativas del país del Cliente que resulten inderogables.`,
        "La versión en español de estos términos es la vigente para los clientes de habla hispana.",
      ],
    },
    {
      h: "15. Contacto y cambios",
      p: [
        `Consultas legales o de facturación: ${CONTACT_EMAIL}.`,
        "Podemos actualizar estos términos; los cambios sustanciales se notificarán por la plataforma o por email con antelación razonable. El uso posterior del Servicio implica aceptación de la versión vigente.",
      ],
    },
  ],
};

export const privacy = {
  title: "Política de Privacidad",
  sections: [
    {
      h: "1. Responsable",
      p: [
        `${LEGAL_ENTITY}, con domicilio en ${LEGAL_ADDRESS}, es responsable del tratamiento de los datos descriptos en esta política respecto de los usuarios de ${BRAND}. Contacto: ${CONTACT_EMAIL}.`,
      ],
    },
    {
      h: "2. Datos que tratamos",
      p: [
        "Datos de cuenta: nombre, email, empresa, credenciales (la contraseña se gestiona por nuestro proveedor de autenticación y no es visible para nosotros).",
        "Datos operativos del depósito: productos, stock, movimientos, pedidos y su historial.",
        "Datos de compradores del Cliente (cuando sincroniza canales de venta): nombre o alias, dirección de envío, contacto y detalle del pedido. Estos datos se procesan POR CUENTA del Cliente, como encargados del tratamiento, al solo efecto de operar su logística.",
        "Datos técnicos: registros de acceso y actividad necesarios para seguridad y soporte.",
        "Datos de facturación: los pagos se procesan en Stripe; NO almacenamos números de tarjeta.",
      ],
    },
    {
      h: "3. Finalidades",
      p: [
        "Prestar el Servicio (sincronizar ventas, gestionar stock y despachos); brindar soporte; facturar; proteger la seguridad de la plataforma; cumplir obligaciones legales; y comunicar novedades del producto (con posibilidad de baja).",
        "No vendemos datos personales ni los usamos para publicidad de terceros.",
      ],
    },
    {
      h: "4. Sub-procesadores",
      p: [
        "Utilizamos proveedores de infraestructura y servicios que procesan datos por nuestra cuenta bajo sus propios compromisos de seguridad:",
        "• Supabase (base de datos y autenticación — AWS, región us-west-2, EE.UU.) · • Google Cloud (cómputo — us-west1, EE.UU.) · • Cloudflare (red y entrega) · • Stripe (pagos) · • Resend u otro proveedor de email transaccional.",
        "Las integraciones que el Cliente conecta (MercadoLibre, Tienda Nube, WooCommerce, transportistas) intercambian datos conforme a los términos de cada plataforma y a las autorizaciones que el propio Cliente otorga.",
      ],
    },
    {
      h: "5. Transferencias internacionales",
      p: [
        "Los datos se alojan en Estados Unidos. Al usar el Servicio, el Cliente consiente esta transferencia. Aplicamos medidas técnicas y organizativas razonables (cifrado en tránsito y en reposo de credenciales, control de acceso, aislamiento por empresa).",
      ],
    },
    {
      h: "6. Conservación",
      p: [
        "Conservamos los datos mientras la cuenta esté activa. Tras la baja, se conservan por hasta 90 días para permitir la exportación y luego se eliminan o anonimizan, salvo obligación legal de conservación mayor (por ejemplo, registros de facturación).",
      ],
    },
    {
      h: "7. Derechos",
      p: [
        `El titular puede ejercer los derechos de acceso, rectificación, actualización y supresión escribiendo a ${CONTACT_EMAIL}.`,
        "Para usuarios en Argentina: la Agencia de Acceso a la Información Pública, en su carácter de órgano de control de la Ley N° 25.326, tiene la atribución de atender las denuncias y reclamos que interpongan quienes resulten afectados en sus derechos por incumplimiento de las normas vigentes en materia de protección de datos personales.",
        "Cuando actuamos como encargados (datos de compradores del Cliente), derivaremos las solicitudes al Cliente responsable.",
      ],
    },
    {
      h: "8. Cookies",
      p: [
        "Usamos almacenamiento local y cookies estrictamente necesarias para la sesión y preferencias. La landing puede usar medición de audiencia y píxeles publicitarios estándar; el navegador permite limitarlos.",
      ],
    },
    {
      h: "9. Cambios",
      p: [
        "Publicaremos las actualizaciones de esta política en esta misma página, indicando la fecha de última actualización.",
      ],
    },
  ],
};

export const refunds = {
  title: "Política de Reembolsos",
  sections: [
    {
      h: "1. Probá gratis antes de pagar",
      p: [
        `${BRAND} ofrece un plan Free, sin costo y sin tarjeta, pensado para evaluar el producto con datos y operación reales antes de contratar un plan pago. Recomendamos usarlo para validar que el Servicio se ajusta a tu operación.`,
      ],
    },
    {
      h: "2. Pagos no reembolsables",
      p: [
        "Los pagos de suscripción (mensuales o anuales) no son reembolsables, ni total ni parcialmente, incluyendo períodos no utilizados.",
        "Este criterio es posible porque el plan Free permite probar el Servicio sin costo y las suscripciones pueden cancelarse en cualquier momento sin penalidad.",
      ],
    },
    {
      h: "3. Cancelación",
      p: [
        "Podés cancelar cuando quieras desde el portal de facturación. La suscripción permanece activa hasta el final del período ya abonado y no se renueva más. La cuenta pasa luego a las condiciones del plan Free (tus datos no se borran).",
      ],
    },
    {
      h: "4. Cambios de plan",
      p: [
        "Al hacer upgrade, el prorrateo del período en curso se calcula y cobra automáticamente a través de Stripe. Al hacer downgrade, el nuevo plan aplica desde el ciclo siguiente.",
      ],
    },
    {
      h: "5. Errores de cobro",
      p: [
        `Si detectás un cobro duplicado o un error objetivo de facturación, escribinos a ${CONTACT_EMAIL} dentro de los 30 días y lo corregimos (incluyendo el reembolso del monto cobrado por error).`,
      ],
    },
  ],
};
